/* src/app/cart/address-container/address-container.component.scss */
ion-nav {
  height: 100%;
  padding: 30px;
}
/*# sourceMappingURL=address-container.component-DTDHN6UM.css.map */
